import { render } from "./AddItemComponent.vue?vue&type=template&id=73770056"
import script from "./AddItemComponent.vue?vue&type=script&lang=js"
export * from "./AddItemComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__